import { TGroupedNotifications, TNotificationsResponse } from '../../types'
import { getArtistImagePath } from 'shared/utils/getArtistImagePath'

export const storiesAdapter =
  (groupedNotifications: TGroupedNotifications, notification: TNotificationsResponse): TGroupedNotifications => {
    const countedStory = groupedNotifications[notification.notification_type ?? '']?.[notification.story?.campaign_id ?? '']

    return {
      ...groupedNotifications,
      ...(notification.notification_type && notification.story?.campaign_id && {
        [notification.notification_type]: {
          ...groupedNotifications[notification.notification_type],
          // group by campaign_id and count
          [notification.story?.campaign_id]: {
            ...notification,
            count: (countedStory?.count ?? 0) + 1,
            ids: [...(countedStory?.ids ?? []), { id: notification.id, notification_type: notification.notification_type }],
            last_updated: Math.max(countedStory?.last_updated ?? 0, new Date(notification.story?.updated_at ?? new Date()).getTime()),
            card: {
              title: notification.story.campaign?.artist?.name ?? '',
              subtitle: notification.story.campaign?.name ?? '',
              imagePath: getArtistImagePath(notification.story.campaign?.artist?.spotify_id, notification.story.campaign?.artist?.facebook_id, 'm'),
              zoneId: notification.story.campaign?.label_id ?? '',
              count: countedStory?.count ? `${countedStory.count + 1} Stories` : '1 Story'
            }
          }
        }
      })
    }
  }